export default __webpack_public_path__ + "static/0205-fcfad3a865f8758d05ed495fbb504a03.png";